<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'PricesListPagination',
  props: {
    paginationIndex: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapActions({
      updatePricesPaginationIndex: 'prices/updatePricesPaginationIndex',
      pricesLoadNewPage: 'prices/pricesLoadNewPage',
    }),
  },
  computed: {
    ...mapState({
      list: state => state.prices.list,
      filter: state => state.prices.filter,
    }),
    showPaginationButton() {
      return this.list.items.length === 200;
    },
    showPagination() {
      return (!this.list.loading
        && !this.filter.loading
        && !this.list.noContent
        && this.list.items.length);
    },
    getPaginationIndex() {
      if (this.list.items.length === 200) {
        return `Showing page ${this.paginationIndex} with 200 results...`;
      }
      return `Showing page ${this.paginationIndex} with ${this.list.items.length} results...`;
    },
  },
};
</script>

<template>
  <v-container>
    <v-flex v-if="showPagination" class="text-xs-center">
      <p>{{ getPaginationIndex }}</p>
      <v-btn
        v-if="showPaginationButton"
        @click="pricesLoadNewPage"
        color="primary"
        outline
      >
        Show more
      </v-btn>
    </v-flex>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/prices/PricesListPagination.vue